/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Code_LabelInputs */

const en_admin_discounts_code_label = /** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const de_admin_discounts_code_label = /** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const es_admin_discounts_code_label = /** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código`)
};

const fr_admin_discounts_code_label = /** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const nl_admin_discounts_code_label = /** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

/** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */
const it_admin_discounts_code_label = en_admin_discounts_code_label;

/** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */
const pt_br2_admin_discounts_code_label = en_admin_discounts_code_label;

/** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */
const pl_admin_discounts_code_label = en_admin_discounts_code_label;

/** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */
const hu_admin_discounts_code_label = en_admin_discounts_code_label;

/** @type {(inputs: Admin_Discounts_Code_LabelInputs) => LocalizedString} */
const ro_admin_discounts_code_label = en_admin_discounts_code_label;

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Admin_Discounts_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_code_label = /** @type {((inputs?: Admin_Discounts_Code_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Code_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_code_label(inputs)
	if (locale === "de") return de_admin_discounts_code_label(inputs)
	if (locale === "es") return es_admin_discounts_code_label(inputs)
	if (locale === "fr") return fr_admin_discounts_code_label(inputs)
	if (locale === "nl") return nl_admin_discounts_code_label(inputs)
	if (locale === "it") return it_admin_discounts_code_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_code_label(inputs)
	if (locale === "pl") return pl_admin_discounts_code_label(inputs)
	if (locale === "hu") return hu_admin_discounts_code_label(inputs)
	return ro_admin_discounts_code_label(inputs)
});
export { admin_discounts_code_label as "admin.discounts.code_label" }